import styled from 'styled-components';
import { animated } from 'react-spring';
import Colors from '../../../config/Colors';
import { Descricao } from '../styles';

export const ConfiguracaoPedidoContainer = styled.div`
    display: flex;
    flex: 1;
    flex-grow: 1;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 1;
    position: relative;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    width: 100%;
`;

export const SwitchContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;
`;

export const SwitchText = styled.span`
    font-family: NunitoSans-Bold;
    font-size: 1.8rem;
    margin-left: 10px;
`;

export const ScrollConfig = styled.div`
    padding: 0 0px 0 25px;
    flex-direction: column;
    display: flex;
    flex: 1;
    overflow: scroll;
    width: 100%;
`;

export const TempoPreparo = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const Form = styled.form``;

export const FieldSet = styled.fieldset`
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const TempoPreparoRow = styled.div`
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    display: flex;
`;

export const TipoPreparoInputContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ValorMinimo = styled(TempoPreparo)``;

export const ValorMinimoRow = styled(TempoPreparoRow)``;

export const ValorMinimoInputContainer = styled(TipoPreparoInputContainer)``;

export const Agendamento = styled(TempoPreparo)``;

export const AgendamentoContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const AgendamentoTipo = styled(AgendamentoContent)``;

export const AgendamentoTipoRow = styled(TempoPreparoRow)``;

export const DescricaoOption = styled(Descricao)`
    display: flex;
    margin: 0 0 0 8px;
`;

export const AgendamentoCheckBoxButton = styled.button`
    background-color: ${Colors.white};
    cursor: pointer;
    border: none;
    justify-content: center;
    max-width: 240px;
    padding-left: 0;
    font-family: NunitoSans-Regular;
    font-size: 1.6rem;
`;

export const AgendamentoCheckBox = styled.input`
    height: 1.5em;
    width: 1.5em;
    margin: 0 10px 0 0;
`;

export const AgendamentoLimite = styled(animated.div)`
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    margin-left: 15px;
    max-width: 300px;
`;

export const AgendamentoLimiteDescricao = styled(Descricao)`
    margin-left: 0;
    margin-bottom: 3px;
`;

export const Horario = styled(Agendamento)``;

export const HorarioContent = styled(AgendamentoContent)``;

export const HorarioSubTitle = styled(Descricao)`
    margin-top: -10px;
    margin-bottom: 20px;
`;

export const HorarioInterval = styled.div`
    margin-bottom: 75px;
`;

export const HorarioPeriod = styled(animated.div)`
    max-width: 240px;
    margin-left: 15px;
`;

export const Footer = styled.footer`
    border-top: 1px solid ${Colors.border};
    min-height: 50px;
    display: flex;
    width: 100%;
    position: fixed;
    background-color: ${Colors.white};
    bottom: 0;
    padding: 10px 0 10px 25px;
    z-index: 101;
`;

export const Button = styled.button`
    border: none;
    min-width: 180px;
    color: white;
    background-color: ${Colors.secondary};
    font-family: NunitoSans-Bold;
    border-radius: 4px;
    font-size: 1.4rem;

    &:hover {
        cursor: pointer;
    }

    &:active {
        opacity: 0.5;
    }
`;
